import { useEffect, useState } from 'react';
import { getFavorites } from '../../services/favoritesService';
import { inviteFreelancer } from '../../services/applicationService';
import Toast from '../Toast/Toast';
import './SharedInviteModal.scss';

export default function ShareInviteModal({ job, onClose }) {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [invitingId, setInvitingId] = useState(null);
  const [invitedIds, setInvitedIds] = useState([]);
  const [toast, setToast] = useState({ message: "", type: "success" });

  const showToast = (message, type = "success") => {
    setToast({ message, type });
  };

  const companyId = localStorage.getItem('userId');

  const fetchFavorites = async () => {
    try {
      setLoading(true);
      const data = await getFavorites(companyId);
      setFavorites(data);
    } catch (err) {
      // console.error('Erro ao carregar favoritos:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyId) fetchFavorites();
  }, [companyId]);

  const handleInvite = async (freelancerId) => {
    setInvitingId(freelancerId);
    try {
      await inviteFreelancer(job.id, freelancerId);
      setInvitedIds(prev => [...prev, freelancerId]);
      showToast('Convite enviado com sucesso!', 'success');
    } catch (err) {
      const msg = err?.response?.data || 'Erro ao enviar convite.';
      showToast(msg, 'error');
    } finally {
      setInvitingId(null);
    }
  };
  return (
    <div className="sim-overlay" onClick={onClose}>
      <div className="sim-modal" onClick={(e) => e.stopPropagation()}>
        <div className="sim-header">
          <div>
            <h3 className="sim-title">Compartilhar vaga</h3>
            <p className="sim-subtitle">{job.title}</p>
          </div>
          <button className="sim-close" onClick={onClose} aria-label="Fechar">×</button>
        </div>

        {loading && <div className="sim-loading">Carregando favoritos...</div>}

        {!loading && favorites.length === 0 && (
          <div className="sim-empty">
            Você ainda não tem freelancers favoritos.
            <br />
            Favorite alguém na tela de Freelancers para poder convidar.
          </div>
        )}

        {!loading && favorites.length > 0 && (
          <div className="sim-list">
            {favorites.map(({ id, freelancer }) => {
              const isInvited = invitedIds.includes(freelancer.id);
              const isLoading = invitingId === freelancer.id;

              return (
                <div key={id} className="sim-item">
                  {freelancer.avatarUrl ? (
                    <img src={freelancer.avatarUrl} alt={freelancer.name} className="sim-avatar" />
                  ) : (
                    <div className="sim-avatar-fallback">
                      {freelancer.name?.slice(0, 2).toUpperCase()}
                    </div>
                  )}

                  <div className="sim-info">
                    <p className="sim-name">{freelancer.name}</p>
                    {freelancer.phone && <p className="sim-phone">{freelancer.phone}</p>}
                  </div>

                  <button
                    className={`sim-btn ${isInvited ? 'sim-btn--sent' : ''}`}
                    disabled={isInvited || isLoading}
                    onClick={() => handleInvite(freelancer.id)}
                  >
                    {isInvited ? 'Convite enviado ✓' : isLoading ? 'Enviando...' : 'Convidar'}
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Toast
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ message: "", type: "success" })}
      />
    </div>
  );
}